<div layout layout-align-items-center class="header-wrap">
  @if (!isEditing) {
    <div class="title">
      <span class="text" margin-right-small-x>
        {{ title }}
      </span>

      <div class="icon-container">
        @if (isEditable) {
          <rt-icon-button
            variant="plain"
            iconName="edit"
            shape="square"
            size="small"
            margin-right-small-xx
            (click)="editClick()"
          >
          </rt-icon-button>
        }
      </div>

      @if (hasRequesterAvatar) {
        <span
          rtTooltip
          [rtTooltipTemplate]="requestedByTooltipTpl"
          [rtTooltipMaxWidth]="300"
          class="avatar-container"
          layout
          margin-right-small-x
        >
          @if (approvalRequest?.requester) {
            <rt-avatar
              [type]="approvalRequest?.requester?.hasAvatar! ? 'image' : 'initials'"
              [initials]="approvalRequest?.requester?.initials!"
              [imageSrc]="approvalRequest?.requester?.photoThumbUrl!"
              [size]="'small-x'"
            ></rt-avatar>
          }
          @if (!approvalRequest?.requester) {
            <rt-avatar type="icon" iconName="person" [size]="'small-x'"></rt-avatar>
          }
        </span>
      }

      <rt-requisitions-status-badge
        [status]="status"
        [isArchived]="isArchived"
      ></rt-requisitions-status-badge>
      @if (isArchived) {
        <rt-badge
          [text]="'app.requisitions.archived' | translate"
          color="counter-default"
          iconName="archive"
        ></rt-badge>
      }
      <rt-badge
        [text]="'#' + guid"
        color="secondary"
        [rtClickToCopy]="guid"
        [rtTooltip]="'app.offer.copy_id' | translate"
      ></rt-badge>
    </div>
  }
  @if (isEditing) {
    <rt-input [autoFocus]="true" [formControl]="titleControl"></rt-input>
    <rt-button
      [disabled]="titleControl.invalid"
      [loading]="isSaving"
      (click)="saveClick()"
      variant="primary"
      margin-left-small
      >{{ 'app.common.save' | translate }}</rt-button
    >
    <rt-icon-button
      [disabled]="isSaving"
      (click)="cancelClick()"
      variant="plain"
      iconName="close"
      margin-left-small
    ></rt-icon-button>
  }
</div>

<ng-template #requestedByTooltipTpl>
  {{ 'app.requisitions.approval_requested_by' | translate }}
  {{ requesterFullName }}
  {{ approvalRequest?.createdAt | rtTimeAgo }}
</ng-template>
